(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.dataset.variantId, 10);
    var labelDefault = btn.dataset.label;
    var labelAdding  = btn.dataset.adding;
    var labelAdded   = btn.dataset.added;

    btn.disabled = true;
    btn.textContent = labelAdding;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = labelAdded;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        });
      setTimeout(function() {
        btn.textContent = labelDefault;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function() {
      btn.textContent = labelDefault;
      btn.disabled = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-cart-drawer"]) return;
  try {
    
(function() {
  var SECTION_ID = 'shopify-section-cg-cart-drawer';
  var isOpen = false;
  var isBusy = false;

  function getDrawer()   { return document.getElementById('cg-cart-drawer'); }
  function getBackdrop() { return document.getElementById('cg-cart-backdrop'); }

  function openDrawer() {
    var d = getDrawer(), b = getBackdrop();
    if (!d) return;
    isOpen = true;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (b) b.classList.add('is-open');
    document.body.classList.add('cg-cart-open');
    d.focus();
  }

  function closeDrawer() {
    var d = getDrawer(), b = getBackdrop();
    if (!d) return;
    isOpen = false;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (b) b.classList.remove('is-open');
    document.body.classList.remove('cg-cart-open');
  }

  function setLoading(on) {
    var d = getDrawer();
    if (!d) return;
    if (on) d.classList.add('cg-cart-drawer--loading');
    else d.classList.remove('cg-cart-drawer--loading');
  }

  function bindEvents() {
    var d = getDrawer(), b = getBackdrop();
    if (!d) return;

    // Close button(s)
    d.querySelectorAll('[data-cart-close]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        if (el.tagName === 'A' || el.tagName === 'BUTTON') { /* allow */ }
        closeDrawer();
      });
    });

    // Backdrop
    if (b) {
      b.addEventListener('click', closeDrawer);
    }

    // Qty buttons
    d.querySelectorAll('[data-qty-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        var key   = btn.getAttribute('data-qty-btn');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var valEl = d.querySelector('[data-qty-val="' + key + '"]');
        var current = valEl ? parseInt(valEl.textContent, 10) : 1;
        var newQty = Math.max(0, current + delta);
        changeQty(key, newQty);
      });
    });

    // Remove buttons
    d.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-remove');
        changeQty(key, 0);
      });
    });
  }

  async function changeQty(key, qty) {
    if (isBusy) return;
    isBusy = true;
    setLoading(true);
    try {
      var cartResp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!cartResp.ok) throw new Error('cart change failed');
      var cartData = await cartResp.json();

      await refreshDrawer();

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));
    } catch (err) {
      console.error('[cg-cart-drawer] changeQty error', err);
    } finally {
      isBusy = false;
      setLoading(false);
    }
  }

  async function refreshDrawer() {
    try {
      var resp = await fetch('/?sections=' + encodeURIComponent('cg-cart-drawer'), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var data = await resp.json();
      var html = data['cg-cart-drawer'];
      if (!html) return;

      var wrapper = document.getElementById(SECTION_ID);
      if (!wrapper) return;

      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newSection = tmp.querySelector('#' + SECTION_ID);
      wrapper.innerHTML = newSection ? newSection.innerHTML : html;

      bindEvents();
      if (isOpen) openDrawer();
    } catch (err) {
      console.error('[cg-cart-drawer] refreshDrawer error', err);
    }
  }

  // Listen for open events
  document.addEventListener('cart:open', function() {
    refreshDrawer().then(openDrawer);
  });

  // Refresh (but don't open) on cart:updated from other sources
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail._source === 'cg-cart-drawer') return;
    refreshDrawer();
  });

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  // Init on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    bindEvents();
    // Wire cart icon buttons
    document.querySelectorAll('[data-cart-icon-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        refreshDrawer().then(openDrawer);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-cart-template"]) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('cg-cart-form');
    if (!form) return;

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cart }
        }));
        // Reload page to reflect changes
        window.location.reload();
      })
      .catch(function(err) { console.error('[cg-cart-page] changeQty error', err); });
    }

    document.querySelectorAll('[data-qty-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key   = btn.getAttribute('data-qty-btn');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var valEl = document.querySelector('[data-qty-val="' + key + '"]');
        var current = valEl ? parseInt(valEl.textContent, 10) : 1;
        changeQty(key, Math.max(0, current + delta));
      });
    });

    document.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        changeQty(btn.getAttribute('data-remove'), 0);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  const tabs = document.querySelectorAll('.cg-faq-tab');
  const tocLinks = document.querySelectorAll('.cg-faq-toc__link[data-faq-toc]');
  const cats = document.querySelectorAll('.cg-faq-cat');

  // Tab click
  tabs.forEach(t => {
    t.addEventListener('click', () => {
      tabs.forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  // TOC scroll-spy
  const setActive = () => {
    let current = '';
    cats.forEach(s => {
      if (window.scrollY + 200 >= s.offsetTop) current = s.id.replace('faq-', '');
    });
    tocLinks.forEach(a => {
      a.classList.toggle('is-active', a.dataset.faqToc === current);
    });
    tabs.forEach(t => {
      t.classList.toggle('is-active', t.dataset.faqTab === current);
    });
  };
  window.addEventListener('scroll', setActive, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var header = document.getElementById('cg-header');
  if (!header) return;

  var mobileToggle = header.querySelector('[data-action="open-mobile-nav"]');
  var mobilePanel = document.getElementById('cg-mobile-nav-panel');
  var mobileBackdrop = document.getElementById('cg-mobile-nav-backdrop');
  var searchOverlay = document.getElementById('cg-search-overlay');
  var searchInput = document.getElementById('cg-search-input');
  var megaTriggers = header.querySelectorAll('[data-mega-trigger]');
  var megaPairs = [];
  megaTriggers.forEach(function(trigger) {
    var panel = document.getElementById(trigger.getAttribute('data-mega-trigger'));
    if (panel) megaPairs.push({ trigger: trigger, panel: panel });
  });

  window.addEventListener('scroll', function() {
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }, { passive: true });

  function openMobileNav() {
    if (!mobilePanel) return;
    mobilePanel.classList.add('is-open');
    mobileBackdrop && mobileBackdrop.classList.add('is-open');
    mobilePanel.setAttribute('aria-hidden', 'false');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobilePanel) return;
    mobilePanel.classList.remove('is-open');
    mobileBackdrop && mobileBackdrop.classList.remove('is-open');
    mobilePanel.setAttribute('aria-hidden', 'true');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileNav);
  document.querySelectorAll('[data-action="close-mobile-nav"]').forEach(function(el) {
    el.addEventListener('click', closeMobileNav);
  });
  document.querySelectorAll('[data-closes-mobile-nav]').forEach(function(el) {
    el.addEventListener('click', closeMobileNav);
  });

  function openSearch() {
    if (!searchOverlay) return;
    closeMobileNav();
    searchOverlay.removeAttribute('hidden');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function() { searchInput.focus(); }, 60);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('hidden', '');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-action="open-search"]').forEach(function(btn) {
    btn.addEventListener('click', openSearch);
  });
  document.querySelectorAll('[data-action="close-search"]').forEach(function(btn) {
    btn.addEventListener('click', closeSearch);
  });
  if (searchOverlay) {
    searchOverlay.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  if (megaPairs.length > 0) {
    var megaTimeout;

    function openMega(active) {
      clearTimeout(megaTimeout);
      megaPairs.forEach(function(pair) {
        if (pair === active) {
          pair.panel.removeAttribute('hidden');
          pair.panel.setAttribute('aria-hidden', 'false');
          pair.trigger.setAttribute('aria-expanded', 'true');
        } else {
          pair.panel.setAttribute('hidden', '');
          pair.panel.setAttribute('aria-hidden', 'true');
          pair.trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function closeMega() {
      megaTimeout = setTimeout(function() {
        megaPairs.forEach(function(pair) {
          pair.panel.setAttribute('hidden', '');
          pair.panel.setAttribute('aria-hidden', 'true');
          pair.trigger.setAttribute('aria-expanded', 'false');
        });
      }, 150);
    }

    megaPairs.forEach(function(pair) {
      pair.trigger.addEventListener('mouseenter', function() { openMega(pair); });
      pair.trigger.addEventListener('mouseleave', closeMega);
      pair.trigger.addEventListener('focus', function() { openMega(pair); });
      pair.trigger.addEventListener('blur', function() {
        setTimeout(function() {
          var focusInPanel = false;
          megaPairs.forEach(function(p) {
            if (p.panel.contains(document.activeElement)) focusInPanel = true;
          });
          if (!focusInPanel) closeMega();
        }, 50);
      });
      pair.panel.addEventListener('mouseenter', function() { clearTimeout(megaTimeout); });
      pair.panel.addEventListener('mouseleave', closeMega);
    });
  }

  document.addEventListener('cart:updated', function(e) {
    var count = e.detail && e.detail.cart && typeof e.detail.cart.item_count === 'number'
      ? e.detail.cart.item_count : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-badge]').forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('cg-cart-badge--hidden', count === 0);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeSearch();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-main-collection"]) return;
  try {
    
(function() {
  /* ── Sort ── */
  var sortSel = document.querySelector('[data-sort-select]');
  if (sortSel) {
    sortSel.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ── Grid / List toggle ── */
  var viewBtns   = document.querySelectorAll('[data-view-btn]');
  var viewPanels = document.querySelectorAll('[data-view-panel]');
  var savedView  = (typeof localStorage !== 'undefined' && localStorage.getItem('cg-plp-view')) || 'grid';

  function setView(v) {
    viewPanels.forEach(function(p) {
      p.style.display = p.dataset.viewPanel === v ? (v === 'list' ? 'flex' : 'grid') : 'none';
    });
    viewBtns.forEach(function(b) {
      var active = b.dataset.viewBtn === v;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { localStorage.setItem('cg-plp-view', v); } catch(e) {}
  }

  setView(savedView);
  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() { setView(this.dataset.viewBtn); });
  });

  /* ── Filter checkboxes — navigate to Shopify-provided URL ── */
  document.querySelectorAll('[data-filter-check]').forEach(function(cb) {
    cb.addEventListener('change', function() {
      window.location.href = this.checked ? this.dataset.urlAdd : this.dataset.urlRemove;
    });
  });

  /* ── Mobile filter sheet ── */
  var backdrop  = document.getElementById('cg-plp-backdrop');
  var sheet     = document.getElementById('cg-plp-sheet');
  var openBtn   = document.querySelector('[data-filter-open]');
  var closeBtns = document.querySelectorAll('[data-filter-close]');

  function openSheet() {
    if (!sheet || !backdrop) return;
    sheet.hidden = false;
    requestAnimationFrame(function() {
      backdrop.classList.add('is-open');
      sheet.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }

  function closeSheet() {
    if (!sheet || !backdrop) return;
    backdrop.classList.remove('is-open');
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function() { if (sheet) sheet.hidden = true; }, 360);
  }

  if (openBtn)   openBtn.addEventListener('click', openSheet);
  if (backdrop)  backdrop.addEventListener('click', closeSheet);
  closeBtns.forEach(function(b) { b.addEventListener('click', closeSheet); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  /* ── Price range — debounced URL navigate ── */
  document.querySelectorAll('[data-price-range]').forEach(function(range) {
    var timer;
    range.addEventListener('input', function() {
      var self = this;
      clearTimeout(timer);
      timer = setTimeout(function() {
        var url = new URL(window.location.href);
        url.searchParams.set(self.name, parseFloat(self.value).toFixed(2));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }, 700);
    });
  });

  /* ── Cart quick-add ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = parseInt(btn.dataset.variantId, 10);
    var labelDef  = btn.dataset.label || btn.textContent;
    var labelAdd  = btn.dataset.adding;
    var labelOk   = btn.dataset.added;
    btn.disabled = true;
    btn.textContent = labelAdd;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = labelOk;
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      setTimeout(function() { btn.textContent = labelDef; btn.disabled = false; }, 1800);
    })
    .catch(function() { btn.textContent = labelDef; btn.disabled = false; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
